export * from './gutachten-post-request.interface';
export * from './gutachten-post-response.interface';
export * from './gutachten-post.shapes';
